var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgEx = function SvgEx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.025L5.939 4.994l3.03-3.058L8.025 1l-3.03 3.06-3.058-3.03L1 1.967l3.062 3.035L1.03 8.063 1.967 9l3.037-3.064 3.06 3.033L9 8.025z",
    fill: "#000"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkgOC4wMjUzM0w1LjkzODY3IDQuOTkzNjdMOC45NjkzMyAxLjkzNTY3TDguMDI1MzMgMUw0Ljk5NTMzIDQuMDU5NjdMMS45MzY2NyAxLjAzMDMzTDEgMS45NjdMNC4wNjIgNS4wMDJMMS4wMzAzMyA4LjA2MzMzTDEuOTY3IDlMNS4wMDQzMyA1LjkzNkw4LjA2NDMzIDguOTY5MzNMOSA4LjAyNTMzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==";
export { SvgEx as ReactComponent };